import React, { forwardRef } from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme-revamp';

const TooltipContent = styled.div<{theme: ITheme}>`
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0.015;
    span {
      font-weight: 600;
      color: ${props => props.theme.colors.primary};
    }
  }

  @media screen and (min-width: 768px) {
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 1.4;
      letter-spacing: 0.015;
      span {
        font-weight: 600;
        color: ${props => props.theme.colors.primary};
      }
    }
  }

  h4 {
    color: ${props => props.theme.colors.primary};
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
  }
  ul {
    li {
     color: ${props => props.theme.colors.grey[1400]};
     font-size: 14px;
     font-weight: 400;
     line-height: 1.8;
     list-style: none;
    }
  }
`;

const TooltipContainer = styled.div<Pick<TooltipProps, 'maxWidth'>>`
  display: inline-block;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + 'px' : 'unset')};
`;

export interface TooltipProps {
  children: JSX.Element;
  maxWidth?: number;
  theme: ITheme;
}

const TooltipBottomSheet = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, ...props }: TooltipProps, ref) => {
    const theme = useTheme();
    
    return (
      <TooltipContainer {...props}>
        <TooltipContent theme={theme}>
          {children}
        </TooltipContent>
      </TooltipContainer>
    );
  }
);

TooltipBottomSheet.defaultProps = {};
export { TooltipBottomSheet };
